import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateSharePassphraseMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  passphrase?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateSharePassphraseMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, passphrase?: string | null } | { __typename?: 'CollectionShare', id: string, passphrase?: string | null } | null } | null };


export const UpdateSharePassphrase = /*#__PURE__*/ gql`
    mutation UpdateSharePassphrase($shareId: ID!, $passphrase: String) {
  updateShare(input: {shareId: $shareId, settings: {passphrase: $passphrase}}) {
    share {
      id
      passphrase
    }
  }
}
    ` as unknown as DocumentNode<UpdateSharePassphraseMutation, UpdateSharePassphraseMutationVariables>;

          

          export const useUpdateSharePassphraseMutation = (options?:MutationHookOptions<UpdateSharePassphraseMutation, UpdateSharePassphraseMutationVariables>) => useMutation(UpdateSharePassphrase, options);
          

          export type UpdateSharePassphraseMutationOptions = MutationHookOptions<UpdateSharePassphraseMutation, UpdateSharePassphraseMutationVariables>;

          

          export type UpdateSharePassphraseMutationResult = ReturnType<typeof useUpdateSharePassphraseMutation>[1];

          
